<template>
  <div class="container">
    <company-text-logo class="logo" />
    <div class="form">
      <router-view />
    </div>
  </div>
</template>

<script>
import CompanyTextLogo from '@/components/icons/CompanyTextLogo.vue'
export default {
  components: {
    CompanyTextLogo,
  },
}
</script>

<style scoped lang="scss">
.container {
  position: relative;
  display: flex;
  height: 100vh;
  margin: auto;

  .logo {
    position: absolute;
    top: 20px;
    left: 40px;
  }
  .form {
    display: flex;
    margin: auto;
    @media only screen and (max-width: $tablet-size) {
      padding: 20px;
      display: flex;
      margin: 60px 0 0 0;
      width: 100%;
    }
  }
}
</style>
